import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc"
import relativeTime from "dayjs/plugin/relativeTime"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(LocalizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
function Footer() {
    const currentYear = dayjs().year();
    return <>
        <footer  className="footer mt-2">
            <Container>
                <Row>
                    <Col sm>
                        <span className="u500">Sage&nbsp;Resources: </span>
                        <span> <a href="https://milespro.sagepub.in/"
                           target="_blank"
                           rel="noopener noreferrer">Sage Miles Pro</a> 
                           {/*, <a href="https://evidya.sagepub.in/evidya/index"
                               target="_blank"
                               rel="noopener noreferrer">e-Vidya</a>, <a href="https://stealadeal.sagepub.in/"
                               target="_blank"
                               rel="noopener noreferrer">StealADeal</a>, <a href="http://blog.sagepub.in/"
                               target="_blank"
                               rel="noopener noreferrer">Blog</a> */}
                        </span>
                        <br/>
                        <span className="u500">What Sage does:</span>
                        <span> <a href="https://in.sagepub.com/en-in/sas/company-information-india"
                           target="_blank"
                           rel="noopener noreferrer">Company</a>, <a href="https://in.sagepub.com/en-in/sas/journals-india"
                               target="_blank"
                               rel="noopener noreferrer">Journals</a>, <a href="https://in.sagepub.com/en-in/sas/digital-library-products-india"
                               target="_blank"
                               rel="noopener noreferrer">Digital&nbsp;Products</a>, <a href="https://journals.sagepub.com/home/sgo"
                               target="_blank"
                               rel="noopener noreferrer">Open&nbsp;Access&nbsp;Journals</a>, <Link to={"/books?access_types=open_access"}>Open&nbsp;Access&nbsp;Books</Link>
                        </span><br/>
                        <span className="u500">Fine&nbsp;print:</span>
                        <span> <a href="https://www.sagepub.com/privacy-india" target="_blank">Privacy&nbsp;Policy</a> 
                        {/*, <Link to="/terms-and-conditions">Terms</Link> */}
                        </span>
                        <br/>
                        <span className="u500">Copyright </span>
                        <span>© {currentYear} Sage Publications India Pvt Ltd</span>
                        <br/>
                    </Col>
                    <Col sm className="footer-get-in-touch">
                        <Row>
                            <Col sm={12} xs={12} className="justify-content-center d-flex p-0">
                                <p className="text-center u500 mb-2">
                                    Keep in touch
                                </p>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-end d-flex p-0">
                                <a href="https://www.facebook.com/SagePublicationsIndiaPvtLtd/"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_facebook.svg" alt={"social facebook"}/>
                                </a>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-center d-flex p-0">
                                <a href="https://www.instagram.com/sage_publications_india/?hl=en"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_instagram.svg" alt={"social instagram"}/>
                                </a>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-start d-flex p-0">
                                <a href="https://www.linkedin.com/company/sage-publications-india-pvt--ltd-"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_linkedin.svg" alt={"social linkedin"}/>
                                </a>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-end d-flex p-0">
                                <a href="https://www.youtube.com/user/sagepublications"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_youtube.svg" alt={"social youtube"}/>
                                </a>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-center d-flex p-0">
                                <a href="https://twitter.com/SagePubIndia"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_twitter.svg" alt={"social twitter"}/>
                                </a>
                            </Col>
                            <Col sm={4} xs={4} className="justify-content-start d-flex p-0">
                                <a href="mailto:spectrum.jps@sagepub.in"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img src="/assets/images/social_mail.svg" alt={"social mail"}/>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </footer>
    </>;

}

export default Footer;
